import { MonitorProgramChangesStepCtrl } from './monitor-program-changes.controller';

export const MonitorProgramChangesStepComponent = {
  controller: MonitorProgramChangesStepCtrl,
  bindings: {
    nextStep: '&',
    prevStep: '&',
    courseDiffs: '<',
    selectedGradDate: '<',
  },
  template: require('./monitor-program-changes.html'),
};
